export default __webpack_public_path__ + "static/media/27.803ca4a5.jpg";